module.exports = __webpack_public_path__ + "static/media/map_1_overview_2.05c10473.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/library/widgets/map/assets/map_1_overview_2.png
// module id = 745
// module chunks = 0